angular.module("MyReportsWidgetModule")
    .directive("myReportsWidget", [
        function () {
            return {
                restrict: 'E',
                templateUrl: '/static/assets/khapps/my_reports/my_reports_widget/MyReportsWidgetDialog.html'
                // replace: true,
            }
        }]
    );